import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { isFalsy } from '@sama/js-core';
import { map } from 'rxjs';
import { TaskWorkspaceStore } from '../../../../../core/h3ml/state/task-workspace-store';
import { settingsStoreToken } from '../../../../../cross-team-shared/state/setting-state';
import { EventTrackingService } from '../../../../../shared/event-tracking/event-tracking.service';
import { toggleState } from '../../../../../shared/misc-utilities/store-utils';
import { RegionOfInterestDistanceComponent } from '../region-of-interest-distance/region-of-interest-distance.component';
import { RegionOfInterestSettingToggleComponent } from '../region-of-interest-setting-toggle/region-of-interest-setting-toggle.component';

@Component({
  selector: 'h3-region-of-interest-settings',
  templateUrl: './region-of-interest-settings.component.html',
  styleUrl: './region-of-interest-settings.component.scss',
  imports: [
    RegionOfInterestSettingToggleComponent,
    RegionOfInterestDistanceComponent,
    AsyncPipe,
    MatDividerModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegionOfInterestSettingsComponent {
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);
  private readonly eventTrackingService = inject(EventTrackingService);

  isSplitViewOff$ = this.taskWorkspaceStore('splitViewOutputName').$.pipe(
    map(isFalsy),
  );

  viewBoxHighlightEnabledStore = inject(settingsStoreToken)(
    'viewBoxHighlightEnabled',
  );

  viewBoxHighlightValueLabel$ = this.viewBoxHighlightEnabledStore.$.pipe(
    map((enabled) => (enabled ? 'Enabled' : 'Disabled')),
  );

  cameraRoiDistanceStore = inject(settingsStoreToken)(
    'regionOfInterestSettings',
  );
  cameraRoiDistanceEnabledLabel$ = this.cameraRoiDistanceStore(
    'enabled',
  ).$.pipe(map((enabled) => (enabled ? 'Enabled' : 'Disabled')));

  protected trackHighlightEnabledChange() {
    toggleState(this.viewBoxHighlightEnabledStore);
    this.eventTrackingService.track({
      id: 'toggle_camera_fov',
      bucket: 'navigation',
      sub_bucket: 'frame',
      new_value: this.viewBoxHighlightEnabledStore.state(),
    });
  }

  protected trackCameraDistanceToggle() {
    toggleState(this.cameraRoiDistanceStore('enabled'));
    this.eventTrackingService.track({
      id: 'toggle_roi_distance',
      bucket: 'navigation',
      sub_bucket: 'frame',
      new_value: this.cameraRoiDistanceStore.state().enabled,
    });
  }
}
